export default {
  studentStatus: {
    id: '',
    nameLocal: '',
    nameEng: '',
  },
  studentStatuses: [],
  processing: false,
  error: null,
  success: null,
}



